import React, {useState} from "react";
import TopBar from "./Components/HomePage/TopBar/TopBar";
import NavBar from "./Components/HomePage/NavBar/NavBar";
import Footer from "./Components/HomePage/Footer/Footer";
import Rout from "./Components/HomePage/Home/Rout";
import { BrowserRouter } from "react-router-dom";
import ShopProducts from "./Components/ShopPage/ShopProduct";
import './App.css'

function App() {
  const [cart, setCart] = useState([])
  const [close, setClose] = useState(false)
  const [detail, setDetail] = useState([])

  const [shopProducts, setShopProducts] = useState(ShopProducts)
  
  const view = (shopProducts)=>{
    setDetail([{...shopProducts}])
    setClose(true)
  }

  

  const addtocart = (Shop)=>{
    const available = cart.find((x)=>{
      return x.id === Shop.id
    })

    if (available){
      alert("This Item is already added to cart")
    }
    else{
      setCart([...cart, {...Shop, qty:1}])
      alert("Item has been added to cart")
    }
  }
  return (
  <div className="body">
    <TopBar/>
    <BrowserRouter>
       <NavBar/>
       <Rout shopProducts={shopProducts} setShopProducts={setShopProducts} detail={detail} view={view} close={close} setClose={setClose} cart={cart} setCart={setCart} addtocart={addtocart}/>
       <Footer/>
    </BrowserRouter>
   
    
  </div>
  );
}

export default App;
